import React from 'react';

const SVG = ({
  style = {},
  fill = '#9192a4',
  width = '100%',
  className = '',
  viewBox = '0 0 25 25',
  title = 'Tenants',
}) => (
  <svg
    fill={fill}
    width={width}
    style={style}
    className={`svg ${className}`}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <style>
        {` .svg-tenants-1 {
                    fill: none;
                }

                .svg-fill-tenants {
                    fill: $ {
                        fill
                    }

                    ;
                }

                `}
      </style>
    </defs>
    <title>{title}</title>
    <g id="Group_8699" transform="translate(-754.283 -1160.283)">
      <path
        id="Rectangle_4614"
        fill="none"
        d="M0 0H25V25H0z"
        transform="translate(754.283 1160.283)"
      />
      <g id="Group_8698" transform="translate(756.283 1162.582)">
        <g id="Group_8697" transform="translate(0 -0.299)">
          <g id="Group_8694" transform="translate(2.104 7.621)">
            <g id="Group_8693">
              <path
                id="Path_5349"
                d="M150.648 428.54v9.271c0 .425-.018.855 0 1.281v.018l.457-.457h-15.7c-.213 0-.425-.007-.638 0h-.027l.457.457v-9.271c0-.425.011-.853 0-1.281v-.018a.457.457 0 1 0-.915 0v9.271c0 .425-.011.853 0 1.281v.018a.465.465 0 0 0 .457.457H151.104a.465.465 0 0 0 .457-.457v-9.271c0-.425.011-.853 0-1.281v-.018a.457.457 0 1 0-.915 0z"
                className="svg-fill-tenants"
                transform="translate(-134.278 -428.082)"
              />
            </g>
          </g>
          <g id="Group_8696" transform="translate(0 0)">
            <g id="Group_8695">
              <path
                id="Path_5350"
                d="M43.068 105.008q.5-.467 1.006-.933l2.42-2.243 2.927-2.715 2.532-2.346c.409-.38.835-.748 1.233-1.141a.131.131 0 0 1 .018-.016h-.647c.348.311.693.624 1.041.935l2.5 2.248 3.01 2.71 2.6 2.342c.423.38.842.766 1.269 1.141.007 0 .011.011.018.016a.458.458 0 0 0 .647-.647c-.348-.311-.693-.624-1.041-.935l-2.5-2.248-3.01-2.71-2.6-2.342c-.423-.38-.842-.766-1.269-1.141-.007 0-.011-.011-.018-.016a.469.469 0 0 0-.647 0q-.5.467-1.006.933l-2.42 2.243-2.931 2.715-2.529 2.342c-.409.38-.832.75-1.233 1.141a.132.132 0 0 1-.018.016.46.46 0 0 0 0 .647.469.469 0 0 0 .647 0z"
                className="svg-fill-tenants"
                transform="translate(-42.288 -94.837)"
              />
            </g>
          </g>
        </g>
        <path
          id="Path_5348"
          d="M15.188 5a2.084 2.084 0 1 0 2.057 2.084A2.081 2.081 0 0 0 15.188 5zm0 4.168a5.99 5.99 0 0 0-2.736.572 2.3 2.3 0 0 0-1.379 1.968v2.323a.693.693 0 0 0 .5.666 11.924 11.924 0 0 0 3.143.492h.943A11.924 11.924 0 0 0 18.8 14.7a.693.693 0 0 0 .5-.666v-2.325a2.3 2.3 0 0 0-1.377-1.969 5.99 5.99 0 0 0-2.735-.572zm0-2.779a.695.695 0 1 1-.686.695.68.68 0 0 1 .686-.695zm0 4.168a4.848 4.848 0 0 1 2.114.42c.483.25.629.475.629.731v1.766a10.216 10.216 0 0 1-2.286.326h-.914a10.215 10.215 0 0 1-2.286-.326v-1.765c0-.256.145-.481.629-.731a4.848 4.848 0 0 1 2.114-.42z"
          className="svg-fill-tenants"
          transform="translate(-4.42 0.988)"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
